import React from 'react';
import './Footer.css';

const CopyRight = () => {
  return (
    <div className="footerBottom" id="footer" style={{ padding: '16px 48px' }}>
      <p
        style={{
          textAlign: 'center',
          width: '100%',
          color: 'white',
          marginBottom: '4px',
        }}
      >
        © Copyright{' '}
        <span
          className=" fw-500"
          style={{ fontWeight: '300', fontSize: '14px' }}
        >
          Aditya BN & Co
        </span>
        . All Rights Reserved
      </p>
      <p
        style={{
          textAlign: 'center',
          width: '100%',
          color: 'white',
          marginBottom: '4px',
        }}
      >
        Designed by
        <span style={{ color: 'var(--buttonBackground)', cursor: 'pointer' }}>
          {' '}
          Koyo Software Solutions
        </span>
      </p>
    </div>
  );
};

export default CopyRight;
